<template>
  <div id="app" class="h-100">
    <!-- 主框架布局 -->
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="css">
#app {
  width: 100%;
  height: 100%;
  overflow-x: auto; /* 允许横向滚动避免数据溢出 */
  overflow-y: auto; /* 纵向可滚动 */
  background: var(--bg-gradient);
}

/* Vue Router 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 页面切换时的滑动效果 */
.slide-fade-enter-active {
  animation: slideInRight 0.3s ease-out;
}

.slide-fade-leave-active {
  animation: slideOutRight 0.3s ease-in;
}

@keyframes slideInRight {
  from {
    transform: translateX(30px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOutRight {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-30px);
    opacity: 0;
  }
}
</style>
